var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8504 2H8.75039C8.39235 2 8.04897 2.14223 7.7958 2.39541C7.54262 2.64858 7.40039 2.99196 7.40039 3.35V6.05C7.40039 6.86 7.94039 7.4 8.75039 7.4H16.8504C17.6604 7.4 18.2004 6.86 18.2004 6.05V3.35C18.2004 2.54 17.6604 2 16.8504 2Z",
    stroke: "#367FFF",
    strokeWidth: 2.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 4.7002H4.7C3.98392 4.7002 3.29716 4.98466 2.79081 5.49101C2.28446 5.99735 2 6.68411 2 7.4002V26.3002C2 27.0163 2.28446 27.703 2.79081 28.2094C3.29716 28.7157 3.98392 29.0002 4.7 29.0002H20.9C21.6161 29.0002 22.3028 28.7157 22.8092 28.2094C23.3155 27.703 23.6 27.0163 23.6 26.3002M18.2 4.7002H20.9C21.6161 4.7002 22.3028 4.98466 22.8092 5.49101C23.3155 5.99735 23.6 6.68411 23.6 7.4002V10.1002M11.45 18.2002H24.5",
    stroke: "#367FFF",
    strokeWidth: 2.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5508 12.7998L24.9508 18.1998L19.5508 23.5998",
    stroke: "#367FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApply);
export default __webpack_public_path__ + "static/media/icon-apply.3cdad20fed608d88fa9c9eab67c4d030.svg";
export { ForwardRef as ReactComponent };